/*
 * ALOHA QUEEN SUPERNOVA
 * Copyright © 2025 Malcolm KH Lee III. All Rights Reserved.
 */

import React from 'react';
import { Shield, Lock, Copyright } from 'lucide-react';

const CopyrightFooter = () => {
  return (
    <footer className="relative z-10 bg-gradient-to-r from-gray-900 via-purple-900/50 to-gray-900 border-t border-purple-500/30 mt-20">
      <div className="container mx-auto px-6 py-8">
        {/* Main Copyright */}
        <div className="text-center mb-6">
          <div className="flex items-center justify-center gap-2 mb-3">
            <Copyright className="w-6 h-6 text-yellow-400" />
            <h3 className="text-2xl font-bold bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-400 bg-clip-text text-transparent">
              Aloha Queen Supernova
            </h3>
          </div>
          <p className="text-lg font-semibold text-white mb-2">
            Copyright © 2025 Malcolm KH Lee III
          </p>
          <p className="text-gray-300 font-medium">
            All Rights Reserved | Proprietary and Confidential
          </p>
        </div>

        {/* Legal Protection Notice */}
        <div className="bg-red-900/20 border border-red-500/50 rounded-lg p-6 mb-6">
          <div className="flex items-start gap-3">
            <Shield className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" />
            <div>
              <h4 className="text-red-300 font-bold text-lg mb-2">Legal Protection Notice</h4>
              <p className="text-gray-300 text-sm leading-relaxed">
                This software and all associated materials are the exclusive intellectual property of 
                <span className="font-bold text-white"> Malcolm KH Lee III</span>. 
                Unauthorized copying, reproduction, distribution, modification, reverse engineering, 
                decompilation, or use of any portion of this work is <span className="font-bold text-red-300">strictly prohibited</span> 
                and will be prosecuted to the fullest extent of the law.
              </p>
            </div>
          </div>
        </div>

        {/* Protected Rights */}
        <div className="grid md:grid-cols-3 gap-4 mb-6">
          <div className="bg-purple-900/20 border border-purple-500/30 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Lock className="w-5 h-5 text-purple-400" />
              <h5 className="text-purple-300 font-semibold">Patent Pending</h5>
            </div>
            <p className="text-gray-400 text-xs">
              Innovative AI agent technology and 3D avatar systems protected under patent law.
            </p>
          </div>
          
          <div className="bg-blue-900/20 border border-blue-500/30 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Lock className="w-5 h-5 text-blue-400" />
              <h5 className="text-blue-300 font-semibold">Trade Secrets</h5>
            </div>
            <p className="text-gray-400 text-xs">
              Proprietary algorithms and business methods protected as trade secrets.
            </p>
          </div>
          
          <div className="bg-pink-900/20 border border-pink-500/30 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Lock className="w-5 h-5 text-pink-400" />
              <h5 className="text-pink-300 font-semibold">Trademark</h5>
            </div>
            <p className="text-gray-400 text-xs">
              "Aloha Queen Supernova" and associated marks are trademarks of Malcolm KH Lee III.
            </p>
          </div>
        </div>

        {/* Additional Legal Info */}
        <div className="text-center text-gray-400 text-xs space-y-1">
          <p>License inquiries: contact@alohanovauniverse.ai</p>
          <p className="font-semibold text-gray-300">
            NO DUPLICATION | NO COPYING | NO UNAUTHORIZED USE
          </p>
          <p>Violators will be prosecuted. This is a legally protected work.</p>
        </div>
      </div>
    </footer>
  );
};

export default CopyrightFooter;